module.exports = __webpack_public_path__ + "img/file-pdf.2a1e1d71.svg";